import * as firebase from "firebase/app";
import { ICanSignInResponse, ICanSignInRequest } from "shared/functions/common/ICanSignIn";
import { SLResponse } from "shared/functions/common";
import { IBasicUserData } from "shared/model/IUser";

import NavigationConstants from "../../../scenes/Navigation/NavigationConstants";
import { Dispatch } from "../../../state/store/store";
import FirebaseFunctionsService from "../functions/FirebaseFunctionsService";

export default class FirebaseAuthService {
  public static async canSignIn(email: string): Promise<SLResponse> {
    try {
      const params: ICanSignInRequest = {
        email
      };

      // TODO: verify
      const res = await FirebaseFunctionsService.canSignIn(params);
      return Promise.resolve(res as SLResponse<ICanSignInResponse>);
    } catch (err) {
      return Promise.reject(`${err}`);
    }
  }

  public static sendMagicLink(email: string): Promise<void> {
    const url = `${window.location.origin}${NavigationConstants.finishSignUp}`;
    const actionCodeSettings = {
      url,
      handleCodeInApp: true
    };

    return firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings);
  }

  public static async finishSignUpWithMagicLink(
    email: string,
    link: string
  ): Promise<any> {
    if (firebase.auth().isSignInWithEmailLink(link)) {
      await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
      return firebase.auth().signInWithEmailLink(email, link);
    } else {
      return Promise.reject("Provided URL is not a magic link");
    }
  }

  public static observeAuthChanges() {
    firebase.auth().onAuthStateChanged(user => {
      console.log(`observeAuthChanges called with user: ${JSON.stringify(user)}`)
      if (user) {
        const { uid, email, displayName } = user;
        Dispatch.auth.updateAuth({ uid, email, displayName });
      } else {
        Dispatch.auth.updateAuth();
      }
    });
  }

  public static async getAuthToken() {
    const currentUser = firebase.auth().currentUser;
    if (currentUser) {
      return currentUser.getIdToken();
    } else {
      console.error("No logged in user");
      return undefined;
    }
  }

  public static async getAuthTokenResult() {
    const currentUser = firebase.auth().currentUser;
    if (currentUser) {
      try {
        return await currentUser.getIdTokenResult();
      } catch (err) {
        console.error(err);
        return undefined;
      }
    } else {
      console.error("No loged in user");
      return undefined;
    }
  }

  public static signOut(): Promise<void> {
    return firebase.auth().signOut();
  }

  public static currentUserBasicData() {
    const user = firebase.auth().currentUser;
    if (user) {
      const basicUserData: IBasicUserData = {
        uid: user.uid,
        displayName: user.displayName,
        email: user.email!
      };

      return basicUserData;
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/firebase/auth/FirebaseAuthService.ts